import { Theme, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { memo } from 'react'
import cardConfig from './trust-cards-config'
import Card from './Card'

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('sm')]: {
        '&:nth-of-type(even)': {
          backgroundColor: theme.palette.grey[50]
        }
      }
    }
  })
)

const SmavaTrustCards = () => {
  const { root } = useStyles()

  const trustCards = [
    {
      logo: cardConfig?.focusMoneyBadgeAlt?.logo,
      title: cardConfig?.focusMoneyBadgeAlt?.title,
      body: cardConfig?.focusMoneyBadgeAlt?.body,
      linkTo: cardConfig?.focusMoneyBadgeAlt?.linkTo
    },
    {
      logo: cardConfig?.guenstigerGehtNicht?.logo,
      title: cardConfig?.guenstigerGehtNicht?.title,
      body: cardConfig?.guenstigerGehtNicht?.body,
      linkTo: cardConfig?.guenstigerGehtNicht?.linkTo
    },
    {
      logo: cardConfig?.focusMoneyBadge?.logo,
      title: cardConfig?.focusMoneyBadge?.title,
      body: cardConfig?.focusMoneyBadge?.body,
      linkTo: cardConfig?.focusMoneyBadge?.linkTo
    },
    {
      logo: cardConfig?.ekomi?.logo,
      title: cardConfig?.ekomi?.title,
      body: cardConfig?.ekomi?.body,
      linkTo: cardConfig?.ekomi?.linkTo
    }
  ]
  return (
    <Grid container spacing={3} direction="row" justifyContent="center">
      {trustCards.map(({ logo, title, body, linkTo }) => (
        <Grid
          item
          key={`trust-card-${title.toLowerCase().replace('', '-')}`}
          className={root}
        >
          <Card logoName={logo} title={title} body={body} linkTo={linkTo} />
        </Grid>
      ))}
    </Grid>
  )
}

export default memo(SmavaTrustCards)
